var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{class:("library-citrix-icons " + _vm.localeClass),staticStyle:{"margin-top":"20px"},attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[(!_vm.UrlBuilder.isInternalUser)?[_c('home')]:[_c('tabbed-home-view')]],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5816a232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = qaf/
// module chunks = 1